<form class="f-col blank-form" [formGroup]="costCenterForm" (ngSubmit)="onSave()">
    <div class="section-heading">
        <h2 class="h2-heading">{{content?.['b2b.managecompany.bicostcenteroverview']}} <div class="dot">.</div> <span class="optional">{{content?.['b2b.managecompany.optional']}}</span>
        </h2>
        <a role="button" class="link" *ngIf="commomObjPipe.costCentreDetails.pipe.length>0 && !Addnew"
            (click)="addNewCostCenter()"><mat-icon fontSet="material-symbols-outlined" class="edit-icon">add</mat-icon>{{content?.['b2b.managecompany.addnew']}}</a>
    </div>

    <div class="section-content" *ngIf="Addnew">
        <div class="inner-contentsection">
            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.bicostcentername']}}</mat-label>
                        <input matInput formControlName="costCenterName" (keypress)="blockInvalidCharacters1($event)"
                            (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)">
                        <mat-error *ngIf="costCenterForm.get('costCenterName')?.hasError('required') "> {{content?.['b2b.managecompany.costcenternamereq']}} </mat-error>
                        <mat-error *ngIf="costCenterForm.get('costCenterName')?.hasError('maxlength')">  {{content?.['b2b.managecompany.costcenternamemaxlimit']}} </mat-error>
                        <mat-error *ngIf="costCenterForm.get('costCenterName')?.hasError('minlength')"> {{content?.['b2b.managecompany.costcenternameminlimit']}} </mat-error>
                    </mat-form-field>
                </div>
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.bicostcentercode']}}</mat-label>
                        <input matInput formControlName="costCenterCode" (keypress)="blockInvalidCharacters1($event)" (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)">
                        <mat-error *ngIf="costCenterForm.get('costCenterCode')?.hasError('required')"> {{content?.['b2b.managecompany.costcentercodereq']}} </mat-error>
                        <mat-error *ngIf="costCenterForm.get('costCenterCode')?.hasError('maxlength')"> {{content?.['b2b.managecompany.costcentercodemaxlimit']}}</mat-error>
                        <mat-error *ngIf="costCenterForm.get('costCenterCode')?.hasError('minlength')"> {{content?.['b2b.managecompany.costcentercodeminlimit']}} </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <label class="mat-label">{{content?.['b2b.managecompany.selectstatus']}}</label>
                        <mat-radio-group aria-label="Select an option" formControlName="status">
                            <mat-radio-button [value]=true selected>{{content?.['b2b.managecompany.active']}}</mat-radio-button>
                            <mat-radio-button [value]=false>{{content?.['b2b.managecompany.inactive']}}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>

            <!-- <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <label class="mat-label">Associate with Branch:</label>
                        <div class="f-row mat-check-group">
                            <mat-checkbox *ngFor="let branch of branchList" class="checkbox-wrapper"
                                (change)="onCheckboxChange($event, branch.id)"
                                [checked]="isEdit  ? findIsChecked(branch) : null"> {{ branch.name }} </mat-checkbox>
                        </div>
                    </div>
                </div>
            </div> -->


            <div class="f-row">
                <mat-form-field class="mat-chip-input custom-mat-dropdown-parent">
                    <mat-label>{{content?.['b2b.managecompany.associateoficelocation']}}</mat-label>
                    <mat-chip-grid #chipGrid aria-label="Fruit selection">
                        <mat-chip-row *ngFor="let name of BranchName" (removed)="remove(name)">
                            {{ name }}
                            <button matChipRemove [attr.aria-label]="'remove ' + name">
                                <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
                            </button>
                        </mat-chip-row>
                    </mat-chip-grid>
                    <input [placeholder]="content?.['b2b.managecompany.select']" #fruitInput [formControl]="associateWithBranch"
                        [matChipInputFor]="chipGrid" [matAutocomplete]="auto"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)"
                        (keypress)="blockInvalidCharacters1($event)" (paste)="onPasteBlocked($event)"
                        (contextmenu)="disableRightClick($event)" maxlength="50" />
                    <mat-icon fontSet="material-symbols-outlined" matSuffix [ngClass]="{'icon-green': BranchName.length > 0}" (click)="fruitInput.focus()">stat_minus_1</mat-icon>
                    <mat-autocomplete #auto="matAutocomplete" class="custom-autocomplete" >
                        <mat-option *ngFor="let branch of filteredBranch | async" [value]="branch.id">
                            <div (keydown.enter)="optionClicked(branch); $event.stopPropagation()" (keyup.space)="optionClicked(branch); $event.stopPropagation()" (click)="optionClicked(branch); $event.stopPropagation()">
                                <mat-checkbox class="checkbox-wrapper" [checked]="selectedBranchIdsMap[branch.id]"
                                    (change)="onCheckboxChange($event, branch,'custom-mat-dropdown-parent','custom-autocomplete')"
                                    (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()"></mat-checkbox>
                                {{ branch.name }}
                            </div>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            <mat-error *ngIf="associateWithBranch.touched && noRecordFound"> {{content?.['b2b.managecompany.recordnotfound']}} </mat-error>

        </div>

        <div class="inner-action">
            <button mat-button class="button--secondary-small" (click)="onCancel()">{{content?.['b2b.managecompany.cancel']}}</button>
            <button mat-button class="button--primary-small" [class.disabled]="costCenterForm.invalid">{{content?.['b2b.managecompany.save']}}</button>
        </div>
    </div>

    <div class="section-table data-listing" *ngIf="commomObjPipe.costCentreDetails.pipe.length>0 && !Addnew">
        <table mat-table [dataSource]="commomObjPipe.costCentreDetails.pipe" class="mat-elevation-z0">
            <!-- Position Column -->
            <ng-container matColumnDef="Cost Center Name">
                <th mat-header-cell *matHeaderCellDef>{{content?.['b2b.managecompany.bicostcentername']}}</th>
                <td mat-cell *matCellDef="let element"> {{element.costCenterName}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="Cost Center Code">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.bicostcentercode']}} </th>
                <td mat-cell *matCellDef="let element"> {{element.costCenterCode}} </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="Status">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.ddstatus']}} </th>
                <td mat-cell *matCellDef="let element" class="status-tag">
                    <span
                        [ngClass]="element.status ? 'status-active' : 'status-inactive'">
                        {{ element.status ? (content?.['b2b.managecompany.active']) : (content?.['b2b.managecompany.inactive']) }}
                    </span>
                </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="Actions">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.ddactions']}} </th>
                <td mat-cell *matCellDef="let element" class="onclick-links">
                    <!-- <a class="onclick-cell primary-link" (click)="onEdit(element)">Edit</a> -->
                    <a tabindex="0" role="button" aria-label="Edit item" class="onclick-cell primary-link" (keydown.enter)="onEdit(element)" (click)="onEdit(element)"><mat-icon fontSet="material-symbols-outlined">edit</mat-icon></a>
                    <!-- <a class="onclick-cell warm-link" (click)="onRemove(element)">Remove</a> -->
                    <a tabindex="0" role="button" aria-label="Remove item" class="onclick-cell warm-link" (keydown.enter)="onRemove(element)" (click)="onRemove(element)"><mat-icon fontSet="material-symbols-outlined">delete</mat-icon></a>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <ng-container *ngIf="!isLoading && commomObjPipe.costCentreDetails.pipe.length==0 && !Addnew">
        <app-cam-empty-state (myEvent)="handleEvent($event)" [heading]="content?.['b2b.managecompany.cconocostcentertitle']"
            [content]="content?.['b2b.managecompany.cconocostcenterdesc']"
            [navigateTo]="'/cam/company-management/cost-center-overview'">
        </app-cam-empty-state>
    </ng-container>
</form>

<ng-template #selectionWarning>
    <div class="custom-dialog">
        <div class="d-justify-bw">
            <div class="custom-dialog__left">
                <div class="mat-dialog-title custom-dialog__title d-justify-bw">
                    <h2 class="mat-dialog-title"> {{content?.warningList[0]?.title}}</h2>
                    <!-- <div class="custom-overlay-close">
                        <mat-icon fontSet="material-symbols-outlined" class="close_icon" (click)="CloseDialog(false)">close</mat-icon>
                    </div> -->
                </div>
                <mat-dialog-content class="custom-dialog__text">
                    <div class="custom-dialog__description">Are you sure you want to remove this cost center?</div>
                </mat-dialog-content>
                <mat-dialog-actions>
                    <div class="dialog-actions-right">
                        <button class="button--secondary-small" mat-button (click)="CloseDialog(false)">{{content?.warningList[0]?.cancelCTAText}}</button>
                        <button class="button--primary-small" mat-button (click)="CloseDialog(true)">{{content?.warningList[0]?.confirmCTAText}}</button>
                    </div>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>